import * as api from "./apis/resetPassword";
import { emit, triggerError } from "../utils/eventManager";
import { sendNewRelicEvent } from "../utils/newRelicEvents";
export { resetPassword };
async function resetPassword(newPassword, token) {
  try {
    sendNewRelicEvent({
      EventName: 'reset_password_start'
    });
    var response = await api.resetPassword(newPassword, token);
    sendNewRelicEvent({
      EventName: 'reset_password_success'
    });
    emit('reset_password.success', response);
    return response;
  } catch (e) {
    sendNewRelicEvent({
      EventName: 'reset_password_failed',
      error: e
    });
    triggerError('reset password', e);
    throw e;
  }
}